import { render, staticRenderFns } from "./SquareViz.vue?vue&type=template&id=3f6d16d0&scoped=true"
import script from "./SquareViz.vue?vue&type=script&lang=js"
export * from "./SquareViz.vue?vue&type=script&lang=js"
import style0 from "./SquareViz.vue?vue&type=style&index=0&id=3f6d16d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6d16d0",
  null
  
)

export default component.exports